<template>
  <div class="btns" v-if="allowSave">
    <button
      class="btn btn-print report-diary__export-button"
      type="button"
      :disabled="!canExport || isExportingPdf"
      @click="$emit('export-pdf')"
    >
      <span class="sienit2">m</span>
      <span>{{ isExportingPdf ? "Експорт..." : "Експорт" }}</span>
    </button>

    <button class="btn btn-close" type="button" @click="$emit('cancel')">
      <span class="sienit">F</span>
      Отказ
    </button>

    <button class="btn btn-new" type="button" @click="$emit('save')">
      <span class="sienit">Y</span>
      Запис
    </button>
  </div>
</template>

<script>
export default {
  name: "ReportActions",
  props: {
    allowSave: Boolean,
    canExport: Boolean,
    isExportingPdf: Boolean,
  },
};
</script>

